import * as React from "react";
import * as DatePicker from "react-datepicker";
import * as moment from "moment";
import {AbstractInputElement, FormElement} from "./FormInput";

class CustomInput extends React.Component<{ value?: any, onClick?: () => void }, {}> {
    render() {
        return (
            <input type="text" className="form-control" onClick={this.props.onClick} onChange={() => {
            }} value={this.props.value}/>
        );
    }
}

interface Props extends FormElement<string, HTMLInputElement> {
    timeZoneId?: string;
    minDate?: Date;
    maxDate?: Date;
}

export class FormDateTimePicker extends AbstractInputElement<string | number, Props, { date?: any, time?: string }> {

    constructor(props) {
        super(props);
        var modelValue = this.getModelValue();
        var currentVal = moment.tz(modelValue, this.props.timeZoneId);
        if (typeof(currentVal) != "undefined") {
            this.state = {date: currentVal, time: currentVal.format("HH:mm")};
        } else {
            this.state = {date: moment().tz(this.props.timeZoneId), time: moment().tz("UTC").format("HH:mm")}
        }
    }

    getDefaultValue() {
        return moment().tz(this.props.timeZoneId).valueOf();
    }

    handleChangeTime(e: React.FormEvent) {
        let value = (e.target as any).value;
        const timezone = this.props.timeZoneId;
        const newDate = moment.tz(this.state.date, timezone).clone();
        const [hours, minutes] = value.split(':').map(Number);
        newDate.set({
            hour: hours,
            minute: minutes,
        });
        this.setState({time: value});
        this.handleModelChange(this.state.date, value)
    }

    handleModelChange(date: any, time: string) {
        const timezone = this.props.timeZoneId;
        const [hours, minutes] = time.split(':').map(Number);
        const newDate = moment.tz(date, timezone).clone();
        newDate.set({
            hour: hours,
            minute: minutes,
        });

        if (isNaN(newDate.valueOf())) {
            this.props.fieldSet.updateModel(this.props.model, newDate ? newDate.valueOf() : 0, false, {
                errorName: "dateTime",
                pristine: false
            });
        } else {
            this.props.fieldSet.updateModel(this.props.model, newDate.valueOf(), false, {errorName: null, pristine: false});
        }
    }

    shouldComponentUpdate(nextProps, nextState) {
        return true;
    }

    handleChange(date) {
        this.setState({date: date});
        this.handleModelChange(date, this.state.time)
    }

    componentDidUpdate(prevProps: Props, prevState) {
        if (this.props.modelValue && !moment(this.props.modelValue).isSame(this.state.date)) {
            this.setState({
                date: moment(this.props.modelValue)
            })
        }
    }


    render() {
        return (
            <div className="form-inline">
                <div className="datetime-picker">
                    <DatePicker 
                        maxDate={this.props.maxDate}
                        minDate={this.props.minDate}
                        customInput={<CustomInput/>} selected={this.state.date}
                                onChange={this.handleChange.bind(this)}/>
                    <input type="text" className="form-control" value={this.state.time}
                           onChange={this.handleChangeTime.bind(this)}/>
                </div>
            </div>
        );

    }

}



// WEBPACK FOOTER //
// ./src/app/ui/form/FormDateTimePicker.tsx